module.exports = __webpack_public_path__ + "static/media/slider-bg1.0d9dc37d.png";